import React from 'react'
import TrackedCardCarousel from 'components/Common/TrackedCardCarousel'
import BodyText from 'components/Luxkit/Typography/BodyText'
import styled from 'styled-components'
import LayoutContainer from 'components/Common/LayoutContainer/LayoutContainer'
import { rem } from 'polished'
import Heading from 'components/Luxkit/Typography/Heading'
import TopPicksForMeCategoryTile from 'components/Recommendations/TopPicksForMe/TopPicksForMeCategoryTile'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

export interface ImageTileItem {
  label: string;
  href: string;
  image: App.Image;
}

interface Props {
  heading: string;
  subheading?: string;
  items: Array<ImageTileItem>
}

const Section = styled(LayoutContainer)`
  padding-top: ${rem(40)};
  padding-bottom: ${rem(40)};
`

function TopPicksForMeCategoryTilesCarousel({
  heading,
  subheading,
  items,
}: Props) {
  return (
    <Section>
      <VerticalSpacer gap={20}>
        <VerticalSpacer gap={8}>
          <Heading variant="heading2">{heading}</Heading>
          {!!subheading && <BodyText variant="medium" colour="neutral-two">{subheading}</BodyText>}
        </VerticalSpacer>
        <TrackedCardCarousel pageSize={6} width={rem(180)}>
          {items.map((item) => (
            <TopPicksForMeCategoryTile
              key={item.label}
              href={item.href}
              image={item.image}
              heading={item.label}
            />
          ))}
        </TrackedCardCarousel>
      </VerticalSpacer>
    </Section>
  )
}

export default TopPicksForMeCategoryTilesCarousel
